import { EContractType, EOfficeType } from '../../api-models/common/json_query';
import { FDealType } from '../types/dealType';
import { FOfferType } from '../types/offerType';

const BUSINESS_FAMILY: FOfferType = FOfferType.Business | FOfferType.RentalBusiness | FOfferType.ReadyBusiness;

export const getContractFields = (
  offerType: FOfferType,
  officeTypes: EOfficeType[],
  dealType: FDealType = FDealType.Unexpected,
): EContractType[] => {
  const isBusinessOnly =
    (offerType & ~BUSINESS_FAMILY) === 0 &&
    (offerType & BUSINESS_FAMILY) !== 0 &&
    officeTypes.length > 0 &&
    officeTypes.every(t => t === EOfficeType.Business);

  if (isBusinessOnly) {
    return [EContractType.ObjSale, EContractType.PermTransfer];
  }

  if ((dealType & FDealType.Sale) !== 0) {
    return [EContractType.ObjSale, EContractType.PermTransfer];
  }

  return [EContractType.DirectRent, EContractType.SubRent];
};
